module.exports = __webpack_public_path__ + "img/saum_oekograu_restpaste.bc82713e.jpg";